<template>
  <div class="buy-card" @click="toDetail()">
    <van-image class="buy-cover" fit="cover" 
    :error-icon="$placeImg"
    :loading-icon="$placeImg"
    :src="cardData.cover" alt="" ></van-image>
    <div class="buy-msg">
      <div class="buy-name ellipsis_two">{{ cardData.name }}</div>
      <div class="buy-des ellipsis">购买时间：{{ cardData.star_time }}</div>
      <div class="buy-des ellipsis">到期时间：{{ cardData.end_time }}</div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    cardData: {
      type: Object,
      default: {},
      required: true,
      validator: function (value) {
        return value;
      },
    },
  },
  computed: {},
  data() {
    return {};
  },
  onLoad() {},
  methods: {
    toDetail(){
      this.$router.push({
        path:'../detail',
        query:{
          id:this.cardData.id,
          type:'video'
        }
      })
    }
  },
};
</script>

<style scoped>
.buy-card {
  width: 100%;
  height: 167px;
  margin-bottom: 26px;
  display: flex;
  padding: 0 30px;
  box-sizing: border-box;
}

.buy-card:last-of-type {
  margin-bottom: 0;
}

.buy-cover {
  width: 296px;
  height: 167px;
  border-radius: 12px;
  display: block;
  flex: 0 1 296px;
  margin-right: 26px;
  overflow: hidden;
}

.buy-msg {
  flex: 0 1 375px;
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  flex-direction: column;
  width: 375px;
}

.buy-name {
  font-size: 32px;
  color: #333;
  font-weight: 600;
  width: 100%;
  margin-bottom: 10px;
}

.buy-des {
  font-size: 24px;  
  color: #666;
  font-weight: 400;
  width: 100%;
  line-height: 1.6;
}

.buy {
  font-size: 38px;
  color: #ff4d41;
  font-weight: 600;
}
</style>>
